module.exports = __webpack_public_path__ + "img/doubleblack_technical-QS0yIuK.svg";